/** WIALON + type D — единственный режим, где флаги #D# осмыслены. */
export function isWialonD(protocol, type) {
    return protocol === 'WIALON' && type === 'D';
}
/**
 * Для WIALON тип только SD|D (по умолчанию SD).
 * Для остальных протоколов type в API — null.
 */
export function normalizeType(protocol, type) {
    if (protocol !== 'WIALON') {
        return null;
    }
    return type === 'D' ? 'D' : 'SD';
}
/** API отдаёт флаги/active как 0|1|boolean. */
export function toFlagBool(value) {
    return value === true || value === 1 || value === '1';
}
/**
 * Тело PUT/POST для Nest /api/retransmission-prefix.
 * send_* независимы; для не-WIALON/не-D бэкенд сам сбросит в false.
 */
export function buildPrefixPayload(prefix, overrides = {}) {
    var _a, _b, _c;
    const next = Object.assign(Object.assign({}, prefix), overrides);
    const type = normalizeType(next.protocol, next.type);
    const wialonD = isWialonD(next.protocol, type);
    return {
        prefix: typeof next.prefix === 'string' ? next.prefix.trim() : next.prefix,
        url: typeof next.url === 'string' ? next.url.trim() : next.url,
        protocol: next.protocol,
        type,
        groupIds: (next.groups || next.transportGroups || []).map((g) => g.id),
        active: next.active === undefined ? undefined : toFlagBool(next.active),
        sendSensors: wialonD ? toFlagBool((_a = next.send_sensors) !== null && _a !== void 0 ? _a : next.sendSensors) : false,
        sendAlarms: wialonD ? toFlagBool((_b = next.send_alarms) !== null && _b !== void 0 ? _b : next.sendAlarms) : false,
        sendGuards: wialonD ? toFlagBool((_c = next.send_guards) !== null && _c !== void 0 ? _c : next.sendGuards) : false,
    };
}
